import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export interface CreateMachineForMachineOnboardingResponse {
  operation_id?: string;
  message?: string;
  detail?: string;
}

export interface CreateMachineForMachineOnboardingPayload {
  gateway_id: string;
  machine_id?: string;
  name: string;
  hostname: string;
  serial_number?: string | null;
}

export const postCreateMachineForMachineOnboarding = async (
  namespace: string,
  payload: CreateMachineForMachineOnboardingPayload,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response =
      await axios.post<CreateMachineForMachineOnboardingResponse>(
        `${url}/api/v4/ns/${namespace}/machines`,
        payload,
        { headers },
      );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    }

    throw new Error("An unexpected error occurred while creating machine.");
  }
};
